<template>
	<div class="full">
		<div class="flex full"
			style="flex-direction: column;box-sizing: border-box;padding: 10px 30px;padding-bottom: 50px;" >
			<div style="margin-top: 15px;">
				<el-input size="mini" placeholder="https://detail.tmall.com/item.htm?id=552280519687&skuId=5925057680083" v-model="url"
					class="input-with-select" clearable>
					<el-button slot="prepend">线上链接</el-button>
				</el-input>
			</div>
			<div style="margin-top: 15px;">
				<el-input size="mini" placeholder="材质报告" v-model="question" class="input-with-select" clearable>
					<el-button slot="prepend">问题</el-button>
				</el-input>
			</div>
			<div style="margin: 10px 0px;">
				<el-button v-if="!loading" size="mini" type="primary" @click="send">生成答案</el-button>
				<div v-else>
					<el-button size="mini" type="success">正在生成...</el-button>
					<el-button size="mini" type="danger" @click="stop">停止生成</el-button>					
				</div>
			</div>
			<div class="chat_container"
				style="position: relative;margin-top: 0px;flex: 1;box-sizing: border-box;padding: 0px 50px;">
				<div class="flex full" style="flex-direction: row;">
					<div class="bord" style="overflow: auto;height: 100%;box-sizing: border-box;padding: 20px;width: 70%;">
						<!-- <div class="markdown-body" v-html="content"></div> -->
						<chatcontainer ref="chatcontainer" @loading="chatcontainerLoading" />
					</div>
					<div class="bord" style="overflow: auto;height: 100%;box-sizing: border-box;padding: 20px;margin-left: 10px;flex: 1;">
						工单form
					</div>
				</div>
			</div>

			<!-- 			<div class="goodsai_text_container bord" style="position: relative;margin-top: 20px;flex: 1">
				<el-input type="textarea" resize="none" style="height: 100%;" :rows="2" placeholder="请输入内容"
					v-model="textarea">
				</el-input>
			</div> -->
		</div>
	</div>
</template>

<style>
	.goodsai_text_container textarea {
		height: 100% !important;
	}

	.chat_container {
		box-sizing: border-box;
		padding: 20px;

	}

	.bord {
		position: relative;
		box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
	}

</style>
<script>
	import chatcontainer from './chatcontainer/index.vue'
	export default {
		name: 'goodsai',

		data() {
			return {
				content: '回复区',
				loading: false,
				url: '',
				question: ''
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			createHB(){
				let res = this.$refs.chatcontainer.createHB()
				console.log(res)
			},
			chatcontainerLoading(e){
				this.loading = e
			},
			send() {
				if (this.loading) {
					this.$message.error('正在查询请稍后')
					return
				}
				if (!this.url || !this.question) {
					this.$message.error('缺少线上链接或问题')
					return
				}
				let param = {
					url: this.url,
					question: this.question,
				}
				this.$api.goodsknowledge.aichattest(param).then(()=>{
					this.$refs.chatcontainer.param = param
					this.$refs.chatcontainer.startStream()
				},()=>{
					
				})
				
			},
			stop() {
				this.$refs.chatcontainer.stopStream()
			}
		},
		components: {
			chatcontainer
		}
	}
</script>